var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dvf"
  }, [_c('div', {
    staticClass: "dvf__head"
  }, [_c('span', [_vm._v("소자 구조 "), _c('small', [_vm._v(_vm._s(_vm.title))])]), _c('small', {
    staticClass: "dvf__hint"
  }, [_vm._v("층에 마우스를 올리면 물질이, 클릭하면 조건 목록이 보입니다")])]), _c('svg', {
    staticClass: "dvf__svg",
    attrs: {
      "viewBox": `0 0 ${_vm.VW} ${_vm.vh}`
    },
    on: {
      "mouseleave": function ($event) {
        _vm.hover = null;
      }
    }
  }, [_vm._l(_vm.shapes, function (s) {
    return _c('g', {
      key: s.key,
      staticClass: "dvf__layer",
      class: _vm.layerClass(s),
      on: {
        "mouseenter": function ($event) {
          _vm.hover = s.key;
        },
        "click": function ($event) {
          return _vm.togglePin(s.key);
        }
      }
    }, _vm._l(s.polys, function (pts, i) {
      return _c('polygon', {
        key: i,
        style: {
          fill: s.color
        },
        attrs: {
          "points": pts
        }
      });
    }), 0);
  }), _vm._l(_vm.tierMarks, function (t) {
    return _c('g', {
      key: 't' + t.label,
      staticClass: "dvf__tier"
    }, [_c('line', {
      attrs: {
        "x1": _vm.FX - 6,
        "y1": t.y0,
        "x2": _vm.FX - 6,
        "y2": t.y1
      }
    }), _c('text', {
      attrs: {
        "x": _vm.FX - 9,
        "y": (t.y0 + t.y1) / 2,
        "transform": `rotate(-90 ${_vm.FX - 9} ${(t.y0 + t.y1) / 2})`
      }
    }, [_vm._v(_vm._s(t.label))])]);
  }), _vm._l(_vm.legend, function (r, i) {
    return _c('g', {
      key: 'l' + r.key,
      staticClass: "dvf__legend",
      class: _vm.layerClass(r),
      attrs: {
        "transform": `translate(${_vm.LX} ${8 + i * _vm.LH})`
      },
      on: {
        "mouseenter": function ($event) {
          _vm.hover = r.key;
        },
        "click": function ($event) {
          return _vm.togglePin(r.key);
        }
      }
    }, [_c('rect', {
      style: {
        fill: r.color
      },
      attrs: {
        "x": "0",
        "y": "1",
        "width": "10",
        "height": "10",
        "rx": "2"
      }
    }), _c('text', {
      attrs: {
        "x": "15",
        "y": "10"
      }
    }, [_vm._v(_vm._s(r.label)), r.filterCount ? _c('tspan', {
      staticClass: "dvf__badge"
    }, [_vm._v(" ● " + _vm._s(r.filterCount))]) : _vm._e()])]);
  })], 2), _vm.current ? _c('div', {
    staticClass: "dvf__panel",
    class: {
      'is-pinned': _vm.pinned
    }
  }, [_c('div', {
    staticClass: "dvf__panel-head"
  }, [_c('b', [_vm._v(_vm._s(_vm.current.label))]), _c('small', [_vm._v(_vm._s(_vm.current.sources.length ? _vm.current.sources.map(function (s) {
    return `${s.nodeName} / ${s.name}`;
  }).join(' · ') : '이 계열에는 해당 속성 값이 없습니다'))]), _vm.pinned ? _c('button', {
    attrs: {
      "type": "button",
      "title": "닫기"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.pinned = null;
      }
    }
  }, [_vm._v("×")]) : _vm._e()]), _vm.current.values.length ? _c('div', {
    staticClass: "dvf__chips"
  }, [_vm._l(_vm.current.values, function (v) {
    return _c('button', {
      key: v.pid + '|' + v.value,
      staticClass: "dvf__chip",
      class: {
        'is-on': v.on
      },
      attrs: {
        "type": "button",
        "title": `${v.nodeName} / ${v.prop}`
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.$emit('toggle-value', v.pid, v.value);
        }
      }
    }, [_vm._v(" " + _vm._s(v.value) + " "), _c('small', [_vm._v(_vm._s(v.count))])]);
  }), _vm.current.more ? _c('small', {
    staticClass: "dvf__more"
  }, [_vm._v("… 외 " + _vm._s(_vm.current.more) + "개 — 트리에서 보기")]) : _vm._e()], 2) : _vm._e(), _vm.current.sources.length ? _c('div', {
    staticClass: "dvf__panel-foot"
  }, [_c('button', {
    staticClass: "dv-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();

        _vm.$emit('open-layer', _vm.current.key, _vm.current.sources.map(function (s) {
          return s.id;
        }));
      }
    }
  }, [_vm._v("트리에서 펼치기")]), _vm.current.filterCount ? _c('button', {
    staticClass: "dv-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();

        _vm.$emit('clear-layer', _vm.current.sources.map(function (s) {
          return s.id;
        }));
      }
    }
  }, [_vm._v("이 층 조건 해제")]) : _vm._e()]) : _vm._e()]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }